import React from 'react';
import VisualisationsToolboxAbstract from '../VisualisationsToolboxAbstract';
import HeatMap from '../../components/analysis/visualisations/HeatMap';

class HeatmapToolbox extends VisualisationsToolboxAbstract {
  static addParams() {}

  static canProcess(nextProps) {
    return (
      nextProps.layer &&
      (nextProps.layer.layer_participation_associations.length > 0 ||
        nextProps.layer.layer_group_participations_associations.length > 0) &&
      nextProps.layer.layer_abstract_type_associations.length > 0 &&
      nextProps.selectedStimuliId !== null
    );
  }

  static getVisualisationComponent() {
    return <HeatMap />;
  }

  static getProcessButtonLabel() {
    return 'Process Layer';
  }

  static getBlockParameters(stimuliId) {
    return {
      extract: false,
      stimuli_id: stimuliId
    };
  }
}

export default HeatmapToolbox;



// WEBPACK FOOTER //
// ./src/scenes/analysis/lib/visualisationTypes/HeatmapToolbox.js